import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { SectionTitle } from '../styles';
import { CommentTextArea } from './styles';

const COMMENT_GUTTER = 68;
const COMMENT_MAX_LENGTH = 500;

interface ResultCommentProps {
	value: string;
	disabled: boolean;
	onChange: (value: string) => void;
	onBlur: () => void;
}

export function ResultComment({ value, disabled, onChange, onBlur }: Readonly<ResultCommentProps>): JSX.Element {
	function handleChange({ target }: React.ChangeEvent<HTMLTextAreaElement>): void {
		onChange(target.value);
	}

	return (
		<Row align="top" gutter={[COMMENT_GUTTER, 0]} wrap={false}>
			<Col>
				<SectionTitle>{I18n.get('Comment')}</SectionTitle>
			</Col>
			<Col flex="auto">
				<CommentTextArea
					showCount
					value={value}
					disabled={disabled}
					maxLength={COMMENT_MAX_LENGTH}
					placeholder={I18n.get('Add your comments here')}
					onChange={handleChange}
					onBlur={onBlur}
				/>
			</Col>
		</Row>
	);
}
